import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Row,
  Col,
  PreviewAltCard,
} from "../../components/Component";
import { Card } from "reactstrap";
import SendingSpendingChart from "./SendingSpendingChart";
import SubscriptionsCard from "./SubscriptionsCard";

const AnalyticsHomePage = () => {
  const [sentMessagesByInterval, setSentMessagesByInterval] = useState([]);
  const [receivedMessagesByInterval, setReceivedMessagesByInterval] = useState([]);
  const [replyRateData, setReplyRateData] = useState(null); // New state for reply rate data
  const [interval, setInterval] = useState("month");
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const navigate = useNavigate();
  const token = Cookies.get('token');

  // Fetch Sent Messages
  const fetchSentMessages = async () => {
    const url = `${global.SERVIP}/analytics/get_messages_by_interval`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ interval }),
      });

      const data = await response.json();
      if (data.ok) {
        setSentMessagesByInterval(data.messages);
      } else {
        console.error("Sent messages error:", data.message);
      }
    } catch (error) {
      console.error("Error fetching sent messages:", error);
    }
  };

  // Fetch Received Messages
  const fetchReceivedMessages = async () => {
    const url = `${global.SERVIP}/analytics/get_received_messages_by_interval`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ interval }),
      });

      const data = await response.json();
      if (data.ok) {
        setReceivedMessagesByInterval(data.messages);
      } else {
        console.error("Received messages error:", data.message);
      }
    } catch (error) {
      console.error("Error fetching received messages:", error);
    }
  };

  // Fetch Subscriptions
  const fetchSubscriptions = async () => {
    const url = `${global.SERVIP}/user/get_subscriptions`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();
      setUserSubscriptions(data.subscriptions);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };

  // Fetch Reply Rate
  const fetchReplyRate = async () => {
    const url = `${global.SERVIP}/analytics/get_reply_rate`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ interval }), // Optional: send interval if needed
      });

      const data = await response.json();
      if (data.ok) {
        setReplyRateData(data); // Store reply rate data in state
      } else {
        console.error("Reply rate error:", data.message);
      }
    } catch (error) {
      console.error("Error fetching reply rate:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchSentMessages();
      fetchReceivedMessages();
      fetchSubscriptions();
      fetchReplyRate(); // Fetch reply rate on component mount or interval change
    }
  }, [interval]);

  return (
    <>
      <Head title="Balance and Overview" />
      <Content>
        <BlockHead size="sm">
          <div className="nk-block-between">
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Analytics
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>Get insights into your messaging activity and subscriptions.</p>
              </BlockDes>
            </BlockHeadContent>
          </div>
        </BlockHead>

        <Block>
          <Row className="g-gs flex-column">
            <Col xs="12" className="mb-4">
              <PreviewAltCard className="w-100">
                <SendingSpendingChart
                  sentMessages={sentMessagesByInterval}
                  receivedMessages={receivedMessagesByInterval}
                  interval={interval}
                  setInterval={setInterval}
                  replyRateData={replyRateData} // Pass reply rate data to the chart component
                />
              </PreviewAltCard>
            </Col>

           
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default AnalyticsHomePage;
